import registration_application from "../../data/guides/el/registration_application.md";
import uom_register from "../../data/guides/el/uom_register.md";
import institutional_account from "../../data/guides/el/institutional_account.md";
import academic_email_activation from "../../data/guides/el/academic_email_activation.md";
import academic_id from "../../data/guides/el/academic_id.md";
import eudoxus_books from "../../data/guides/el/eudoxus_books.md";
import library_registration from "../../data/guides/el/library_registration.md";
import open_eclass from "../../data/guides/el/open_eclass.md";
import boarding from "../../data/guides/el/boarding.md";
import housing from "../../data/guides/el/housing.md";
import healthcare from "../../data/guides/el/healthcare.md";

export default {
  registration_application_guide: registration_application,
  uom_register_guide: uom_register,
  institutional_account_guide: institutional_account,
  academic_email_activation_guide: academic_email_activation,
  academic_id_guide: academic_id,
  eudoxus_books_guide: eudoxus_books,
  library_registration_guide: library_registration,
  open_eclass_guide: open_eclass,
  boarding_guide: boarding,
  housing_guide: housing,
  healthcare_guide: healthcare,
  return_to_guides_list: "Επιστροφή στη λίστα οδηγών",
  registration_application_title: "Αίτηση εγγραφής επιτυχόντα/ούσας",
  uom_register_title: "Είσοδος στη σελίδα UoM Register",
  institutional_account_title: "Ιδρυματικός λογαριασμός",
  academic_email_activation_title: "Ενεργοποίηση ακαδημαϊκού email",
  academic_id_title: "Ακαδημαϊκή ταυτότητα",
  eudoxus_books_title: "Βιβλία από Εύδοξο",
  library_registration_title: "Εγγραφή στη βιβλιοθήκη",
  open_eclass_title: "Εγγραφή στο Open eClass",
  boarding_title: "Σίτιση",
  housing_title: "Στέγαση",
  healthcare_title: "Υγειονομική περίθαλψη",
};
